import React from 'react';
import Editor from 'react-quill';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { red } from '@mui/material/colors';

import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const formats = ['bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent'];

const useStyles = makeStyles(theme => ({
  root: {
    '& .ql-editor': {
      minHeight: 150,
      fontSize: '1rem',
      fontFamily: theme.typography.fontFamily,
    },
    '& .ql-blank::before': {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontFamily: theme.typography.fontFamily,
    },
  },
  error: {
    '& .ql-toolbar': {
      borderColor: red[500],
    },
    '& .ql-container': {
      borderColor: red[500],
    },
    '& .ql-blank::before': {
      color: red[500],
    },
  },
  inactive: {
    pointerEvents: 'none',
    cursor: 'default',
    opacity: 0.6,
  },
}));

const TextEditor = ({ className, value, onChange, error, placeholder, disabled }) => {
  const classes = useStyles();

  // When we type something and delete all the text, it holds an empty tags ("<p><br></p>") so we should fix it
  const handleChange = newValue => (newValue === '<p><br></p>' ? onChange('') : onChange(newValue));

  return (
    <Editor
      className={clsx({
        [classes.root]: true,
        [classes.error]: error,
        [classes.inactive]: disabled,
        [className]: Boolean(className),
      })}
      value={value}
      onChange={handleChange}
      modules={modules}
      formats={formats}
      placeholder={placeholder}
      theme="snow"
    />
  );
};

TextEditor.defaultProps = {
  className: '',
  value: '',
  error: false,
  placeholder: '',
  disabled: false,
};

TextEditor.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TextEditor;
